import React from "react";

/* =======================
   Styles
======================= */
import styles from "./Button.module.scss";

const Button = ({ text, icon: Icon, onClick, className = "", ...props }) => {
  return (
    <button
      className={`${styles["admin-primary-button"]} ${className}`}
      onClick={onClick}
      {...props}
    >
      {Icon && (
        <span className={styles["admin-primary-button__icon"]}>
          {/* Automatically handles both lucide-react components and legacy image paths */}
          {typeof Icon === "string" ? (
            <img
              src={Icon}
              alt="icon"
              className={styles["admin-primary-button__img"]}
            />
          ) : (
            <Icon />
          )}
        </span>
      )}
      {text}
    </button>
  );
};

export default Button;
